/**
 * バリデーションユーティリティ
 * 医療データのバリデーションルールを提供する
 */

type ValidationResult = {
  isValid: boolean;
  message: string;
};

/**
 * ER/PR（エストロゲン受容体/プロゲステロン受容体）の組み合わせをバリデーション
 * 両方が陰性（ID=1）の場合は無効
 * @param esStsId - エストロゲン受容体のステータスID
 * @param prStsId - プロゲステロン受容体のステータスID
 * @returns バリデーション結果
 */
export const validateErPrCombination = (
  esStsId: string | number,
  prStsId: string | number
): ValidationResult => {
  if (esStsId === 1 && prStsId === 1) {
    return {
      isValid: false,
      message: "エストロゲン受容体とプロゲステロン受容体のどちらかが陽性である必要があります。"
    };
  }
  return { isValid: true, message: "" };
};

/**
 * Ki67の値をバリデーション
 * @param ki67Per - Ki67の値
 * @returns バリデーション結果
 */
export const validateKi67 = (
  ki67Per: number | string | null | undefined
): ValidationResult => {
  // 必須チェック
  if (ki67Per === null || ki67Per === undefined || ki67Per === "") {
    return {
      isValid: false,
      message: "Ki67の割合を入力してください。"
    };
  }

  // 数値チェック
  const ki67Value = String(ki67Per).trim();
  if (isNaN(Number(ki67Value)) || ki67Value === "") {
    return {
      isValid: false,
      message: "Ki67の割合は数値で入力してください。"
    };
  }

  // 範囲チェック（0-100%）
  const ki67Number = Number(ki67Value);
  if (ki67Number < 0 || ki67Number > 100) {
    return {
      isValid: false,
      message: "Ki67の割合は0から100の範囲で入力してください。"
    };
  }

  return { isValid: true, message: "" };
};

/**
 * 必須文字列フィールドのバリデーション
 * @param value - 検証する値
 * @param fieldName - フィールド名（エラーメッセージ用）
 * @returns バリデーション結果
 */
export const validateRequiredString = (
  value: string | null | undefined,
  fieldName: string
): ValidationResult => {
  if (!value || value.trim() === "") {
    return {
      isValid: false,
      message: `${fieldName}は必須です。`
    };
  }
  return { isValid: true, message: "" };
};
